import { render, staticRenderFns } from "./InitialInfoModal_v2.vue?vue&type=template&id=2c5ef87c"
import script from "./InitialInfoModal_v2.vue?vue&type=script&lang=js"
export * from "./InitialInfoModal_v2.vue?vue&type=script&lang=js"
import style0 from "./InitialInfoModal_v2.vue?vue&type=style&index=0&id=2c5ef87c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports